const noop = () => { };
// Pipelining core Function -  pass data between pipes
export const createPipeline = (pipeArr) => {
    if (!pipeArr || !pipeArr.reduce || !pipeArr.length) {
        throw new TypeError('createPipeline need at least one function param');
    }
    if (pipeArr.length === 1) {
        return (msg, resolve) => {
            pipeArr[0](msg, resolve || noop);
        };
    }
    return pipeArr.reduce((prePipe, pipe) => (msg, nextPipe = noop) => prePipe(msg, (msg) => pipe === null || pipe === void 0 ? void 0 : pipe(msg, nextPipe)));
};
export { sendNormalLogPipe } from './send';
export { throttlePipe } from './throttle';
export { errorLogLimitPipe } from './errorRepeatLimit';
